


























































import Vue from 'vue'

import Contact from '@/component/Contact.vue'
import Subscribe from '@/component/Subscribe.vue'

export default Vue.extend({
  name: 'ApplicationFooter',
  components: {
    Contact,
    Subscribe
  }
})
